import React from 'react'
import styles from './Project.module.css'

export const Project = ({ name, description, website, websiteName }) =>
  <div className={styles.project}>
    <span className={styles.name}>{name}</span>
    {website && <a className={styles.website} href={website}>{websiteName || website}</a>}
    <span className={styles.overview}>{description}</span>
  </div>
